import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates that the input is either empty or contains a postal code
 * (4 digits min, to allow neighboring countries) followed by a city name.
 * A valid input must match the pattern: exactly 5 digits, a space, and a non-empty city name.
 * Examples of valid input: "10115 Berlin", "40210 Düsseldorf", "6291 Vaals" (the Netherlands)
 * Examples of invalid input: "123", "Berlin", "101 Hamburg", "abc Hamburg"
 */
export function postalCodeAndCityValidator(): ValidatorFn {
	const pattern = /^\s*$|^\d{4,}\s+\S+/;

	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;

		if (!value || pattern.test(value)) {
			return null;
		}

		return { invalidPostalCodeAndCity: true };
	};
}
